import { render, staticRenderFns } from "./prevencion-emergencias-actas-editar.vue?vue&type=template&id=2a1e11cc&scoped=true&"
import script from "./prevencion-emergencias-actas-editar.vue?vue&type=script&lang=js&"
export * from "./prevencion-emergencias-actas-editar.vue?vue&type=script&lang=js&"
import style0 from "./prevencion-emergencias-actas-editar.vue?vue&type=style&index=0&id=2a1e11cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1e11cc",
  null
  
)

export default component.exports